import { More } from '@icon-park/react';
import { noop } from 'lodash';
import { memo, type ReactElement, useCallback } from 'react';

import { useHover } from '@didaskill/ui/utils';

import { Button, type ButtonProps } from '../../../general/button/Button';

export type PaginationEllipsisButtonProps = Omit<ButtonProps, 'onClick'> & {
  page: number;
  hoverIcon?: ReactElement;
  onClick?: (page: number) => void;
};

export const PaginationEllipsisButtonBase = ({
  page,
  hoverIcon,
  onClick = noop,
  ...props
}: PaginationEllipsisButtonProps) => {
  const onClickProxy = useCallback(() => onClick(page), [onClick, page]);

  const { isHovered, ...hoverProps } = useHover(props);

  return (
    <Button
      {...props}
      {...hoverProps}
      size={Button.SIZES.SMALL}
      onClick={onClickProxy}
      variant={Button.VARIANTS.NEUTRAL}
      icon={isHovered ? hoverIcon : <More />}
    />
  );
};

PaginationEllipsisButtonBase.displayName = 'PaginationEllipsisButton';

export const PaginationEllipsisButton = memo(PaginationEllipsisButtonBase);
